import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import MasterAppsContainer from 'components/settings/DynamicApplicationGeneration/MasterApps/MasterAppsContainer';
import FiltersContainer from 'components/settings/DynamicApplicationGeneration/Filters/FiltersContainer';
import FilterValuesContainer from 'components/settings/DynamicApplicationGeneration/FilterValues/FilterValuesContainer';
import DynamicAppsContainer from 'components/settings/DynamicApplicationGeneration/DynamicApps/DynamicAppsContainer';
import DynamicApplicationGeneration from 'components/settings/DynamicApplicationGeneration';

const DagContainer = () => {
    const match = useRouteMatch();
    const basePath = match.path;
    return (
        <Switch>
            <Route
                path={`${basePath}/master-apps`}
                component={MasterAppsContainer}
            />
            <Route path={`${basePath}/filters`} component={FiltersContainer} />
            <Route
                path={`${basePath}/filter-values`}
                component={FilterValuesContainer}
            />
            <Route
                path={`${basePath}/dynamic-apps`}
                component={DynamicAppsContainer}
            />
            <Route component={DynamicApplicationGeneration} />
        </Switch>
    );
};

export default DagContainer;
